// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '../../DataCache';
import { Instrument } from '../../cache/Instrument';
import { Resources } from '@shared/localizations/Resources';
import { TvSymbolConvertor } from '../Convertors/TvSymbolConvertor';
class _TvInstrumentTypesManager {
    constructor() {
        this.AllTypes = 'all';
    }
    getInstrumentTypes() {
        let instrumentTypes = DataCache.NonFixedList ? this.getInstrumentTypesByInstrumentGroup() : [];
        if (instrumentTypes.length === 0) {
            instrumentTypes = this.getInstrumentTypesByOldScheme();
        }
        if (instrumentTypes.length === 0) {
            return [];
        }
        const symbolTypes = [];
        for (const instType of instrumentTypes) {
            const symbolTypeValue = TvSymbolConvertor.getSymbolType(instType);
            const exists = symbolTypes.some((symbolType) => symbolType.value === symbolTypeValue);
            if (exists) {
                // for CFDs
                continue;
            }
            const tvSymbolType = {
                name: Instrument.getTypeString(instType),
                value: symbolTypeValue
            };
            symbolTypes.push(tvSymbolType);
        }
        symbolTypes.sort(this.compareTo);
        const allSymbolType = {
            name: Resources.getResource('panel.TerceraSymbolLookupDropDownForm.typeComboBox.All types'),
            value: this.AllTypes
        };
        symbolTypes.unshift(allSymbolType);
        return symbolTypes;
    }
    getInstrumentTypesByInstrumentGroup() {
        const instrumentTypes = [];
        for (const type in DataCache.instrTypes) {
            const instrumentType = DataCache.instrTypes[type];
            const instType = instrumentType.InstrumentType;
            if (!isNullOrUndefined(instType) && !instrumentTypes.includes(instType)) {
                instrumentTypes.push(instType);
            }
        }
        return instrumentTypes;
    }
    /*
     * This method is used for compatibility with the old scheme.
     */
    getInstrumentTypesByOldScheme() {
        const instrumentTypes = [];
        if (DataCache.NonFixedList) {
            return [];
        }
        const existingInstrumentTypes = DataCache.ExistingInstrumentTypes;
        for (let i = 0; i < existingInstrumentTypes.length; i++) {
            const instType = existingInstrumentTypes[i];
            if (!isNullOrUndefined(instType) && !instrumentTypes.includes(instType)) {
                instrumentTypes.push(instType);
            }
        }
        return instrumentTypes;
    }
    compareTo(a, b) {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0; // a и b равны
    }
}
export const TvInstrumentTypesManager = new _TvInstrumentTypesManager();
